import React from "react";
import moment from "moment";
import Link from "gatsby-link";
import GatsbyConfig from "../../../gatsby-config.js";
import {
  setInLocal,
  buildPerksHTMLforTrip,
  getPlanChangeData,
  isHawaiiTime,
  getRoomPrice,
  getParamFromQueryString,
} from "../../utils/app-helpers";
import HelmetWrapper from "../partials/helmet-wrapper";
import Banners from "../partials/banners";
import CouponReminder from "../partials/coupon-reminder";
import Image from "../partials/image";
import OnLocationBanner from "../partials/onlocation-banner";
import OnLocationContent from "../partials/onlocation-content";
import OnLocationHeader from "../partials/onlocation-header";
import RoomCard from "../partials/room-card";
import RoomRibbon from "../partials/room-ribbon";
import SiteFooter from "../partials/site-footer";
import SiteHeader from "../partials/site-header";
import ThinBar from "../partials/thin-bar";
import TripHeader from "../partials/trip-header";

import logoRitzCancun from "../../../static/images/logos/ritz-cancun.png";
import logoRitzKapalua from "../../../static/images/logos/ritz-kapalua.png";
import logoGrandHyattKauai from "../../../static/images/logos/grand-hyatt-kauai.png";
import logoFairmontKeaLani from "../../../static/images/logos/fairmont-kea-lani.png";

const imageMapping = {
  "ritz-cancun": logoRitzCancun,
  "ritz-kapalua": logoRitzKapalua,
  "grand-hyatt-kauai": logoGrandHyattKauai,
  "fairmont-kea-lani": logoFairmontKeaLani,
};
const { siteMetadata: config } = GatsbyConfig;

export default class RoomPage extends React.Component {
  componentDidMount() {
    const { trip } = this.props;

    setInLocal("lsg.last-viewed-trip", trip);
  }

  formatPrice(price) {
    return price > 999
      ? `$${price}`.replace(/(.+)(\d{3})$/, "$1,$2")
      : `$${price}`;
  }

  render() {
    if (typeof window === "undefined") return <div />;
    const { trip, location } = this.props;
    if (!trip) return <main />;
    const tripData = config.trips[trip];
    const { disableMonthlyPaymentOption, disableRoomPricing } = tripData;
    const roomId = location
      ? location.search.replace(/.*\??room=([^&]+).*/i, "$1")
      : "";
    let room;
    try {
      room = tripData.rooms[roomId];
    } catch (e) {}
    if (!room) return <main />;
    const title = "Select Room Type";
    const description =
      "Learn more about the different room options we have available!";
    const { xMonths, planChangeDay } = getPlanChangeData(tripData, { moment });
    const subscriptionFee = tripData.subscriptionFee * 100;
    const perPersonFees = tripData.taxesAndFees * 100;
    const priceFull = getRoomPrice(tripData, room) * 100;
    const pricePerPerson = (priceFull - perPersonFees) / 2;
    const priceMonthly = Math.round(
      (priceFull + subscriptionFee) / xMonths / 2
    );
    const perksHTML = buildPerksHTMLforTrip(tripData);
    const shouldCall = tripData.useHawaiiPhoneGate && isHawaiiTime();
    const promo = getParamFromQueryString("promo", window.location.href);
    const upgraded = getParamFromQueryString("upgraded", window.location.href);
    const isValidPromo = Object.keys(room.prices).includes(promo);
    const isValidUpgrade =
      upgraded && Object.keys(tripData.rooms).includes(upgraded);
    const isOnlocation = promo && promo === "onlocation";
    const onLocationCutoffDateUTC = moment.utc(
      tripData.onLocationPricingCutoff
    );
    const fromTab = getParamFromQueryString("tab", window.location.href);
    const isValidTab = ["rooms", "suites", "all"].includes(fromTab);
    const monthlyPricingAvailable =
      !tripData.disableMonthlyPaymentOption && priceMonthly > 0;
    let upsellRoom = null;
    let upsellPriceFull = 0;
    let upsellMonthlyPrice = 0;
    let upsellMonthlyIncrease = 0;
    let upsellPerPersonIncrease = 0;

    if (upgraded) {
      window.scrollTo(0, 0);
    } else if (room.upsell) {
      upsellRoom = tripData.rooms[room.upsell];

      if (upsellRoom.soldOut) {
        upsellRoom = null;
      } else {
        upsellPriceFull = getRoomPrice(tripData, upsellRoom);
        upsellMonthlyPrice = Math.round(
          (upsellPriceFull + subscriptionFee / 100) / xMonths / 2
        );
        upsellMonthlyIncrease =
          upsellMonthlyPrice - Math.round(priceMonthly / 100);
        upsellPerPersonIncrease = (upsellPriceFull - priceFull / 100) / 2;
      }
    }
    return (
      <div
        className={`page-room trip-${trip}${isOnlocation ? " big-header" : ""}`}
      >
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        {isOnlocation ? (
          <OnLocationHeader
            trip={trip}
            backTo={`/${trip}/onlocation${isValidTab ? `?tab=${fromTab}` : ""}`}
          />
        ) : (
          <SiteHeader trip={trip} lock step="2" />
        )}
        <TripHeader trip={trip} />
        <CouponReminder trip={trip} />
        <OnLocationContent trip={trip} skip={promo !== "onlocation"}>
          <main>
            <div
              style={{ backgroundImage: `url(${room.header})` }}
              className="image mobile-100x40 desktop-300"
            >
              <RoomRibbon room={room} />
            </div>
            {isOnlocation ? (
              <OnLocationBanner trip={trip} showExtra />
            ) : (
              <Banners trip={trip} />
            )}
            {!!tripData.thinBar2 && !tripData.soldOut && (
              <ThinBar message={tripData.thinBar2} />
            )}
            <div className="wrap">
              <div className={`content${upsellRoom ? " with-sidebar" : ""}`}>
                <h1>{room.name}</h1>
                <section>
                  <p>{room.description}</p>
                  {tripData.soldOut || room.soldOut ? (
                    <p className="soldout-notice">Sold Out</p>
                  ) : disableRoomPricing ? (
                    <hr />
                  ) : (
                    <div>
                      <div
                        className={`button-bar ${
                          monthlyPricingAvailable ? "split" : "single"
                        }`}
                      >
                        {monthlyPricingAvailable && (
                          <Link
                            className="btn btn-primary"
                            to={`/${trip}/${
                              shouldCall ? "call-to-" : ""
                            }book?room=${roomId}&pay=monthly${
                              isValidPromo ? `&promo=${promo}` : ""
                            }${isValidUpgrade ? `&upgraded=${upgraded}` : ""}`}
                          >
                            Pay Monthly
                          </Link>
                        )}
                        <Link
                          className="btn"
                          to={`/${trip}/${
                            shouldCall ? "call-to-" : ""
                          }book?room=${roomId}&pay=full${
                            isValidPromo ? `&promo=${promo}` : ""
                          }${isValidUpgrade ? `&upgraded=${upgraded}` : ""}`}
                        >
                          {monthlyPricingAvailable ? (
                            "Book Room"
                          ) : (
                            <span>
                              Pay <small>in</small> Full
                            </span>
                          )}
                        </Link>
                      </div>
                      <p className="room-price">
                        <i className="fa fa-tag" />
                        <span>
                          {monthlyPricingAvailable && (
                            <span>
                              {this.formatPrice(Math.round(priceMonthly / 100))}
                              <small> for {xMonths} months or </small>
                              <br />
                            </span>
                          )}
                          {this.formatPrice(pricePerPerson / 100)}
                          <small> per person</small>
                        </span>
                      </p>
                      {!monthlyPricingAvailable ? (
                        <hr />
                      ) : (
                        <p className="price-meta">
                          <span>
                            <strong>{xMonths} Month plan</strong>
                            <span> available until </span>
                            {promo === "onlocation" ? (
                              <strong>
                                {onLocationCutoffDateUTC
                                  .utcOffset(-7)
                                  .format("MMMM D, YYYY")}
                                .
                              </strong>
                            ) : (
                              <strong>
                                {planChangeDay.format("MMMM D, YYYY")}.
                              </strong>
                            )}
                          </span>
                          <span>
                            &nbsp;Monthly payments are per person and include a
                            one time {this.formatPrice(subscriptionFee / 200)}pp
                            convenience fee and the{" "}
                            {this.formatPrice(perPersonFees / 200)}pp taxes &
                            fees.
                          </span>
                        </p>
                      )}
                    </div>
                  )}
                  <div className="cols">
                    <div className="perks">
                      <h4>Love Song Couples Getaway Includes:</h4>
                      <div dangerouslySetInnerHTML={{ __html: perksHTML }} />
                    </div>
                    <div className="venue-logo">
                      <Image
                        src={imageMapping[tripData.venueSlug]}
                        alt={tripData.venue}
                      />
                    </div>
                  </div>
                </section>
                {!!upsellRoom && (
                  <aside>
                    {disableRoomPricing ? (
                      <h2>Also consider</h2>
                    ) : !monthlyPricingAvailable ? (
                      <h2>
                        Upgrade for only <br /> ${upsellPerPersonIncrease} more
                        per person
                      </h2>
                    ) : (
                      <h2>
                        Upgrade for only <br /> ${upsellMonthlyIncrease} more
                        per month
                      </h2>
                    )}
                    <RoomCard
                      trip={trip}
                      room={upsellRoom}
                      monthlyPrice={upsellMonthlyPrice}
                      upgraded={room.key}
                    />
                  </aside>
                )}
                <hr />
                <p>
                  {monthlyPricingAvailable
                    ? config.doubleOccupancyDisclaimer
                    : config.doubleOccupancyDisclaimerNoMonthly}
                </p>
              </div>
            </div>
          </main>
        </OnLocationContent>
        <SiteFooter trip={trip} hideTrips={isOnlocation} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/room.js